import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard} from './core/guards/role.guard';
import {NewTemplateComponent} from './components/new-template/new-template.component';
import {TemplatesListComponent} from './components/templates-list/templates-list.component';
import {DashboardComponent} from './components/dashboard/dashboard.component';
import {LayoutComponent} from './components/layout/layout.component';
import {UnauthorizedComponent} from './components/unauthorized/unauthorized.component';
import { NewContractComponent } from './components/new-contract/new-contract.component';
import { ContractListComponent } from './components/contract-list/contract-list.component';
import { CartComponent } from './components/cart/cart.component';
import { CheckoutComponent } from './components/checkout/checkout.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'neue-vorlage',
        component: NewTemplateComponent,
        canActivate: [authGuard, roleGuard],
        data: { roles: ['ADMIN'] }
      },
      {
        path: 'vorlagenliste',
        component: TemplatesListComponent,
        canActivate: [authGuard, roleGuard],
        data: { roles: ['ADMIN'] }
      },
      {
        path: 'neuer-vertrag',
        component: NewContractComponent,
      },
      {
        path: 'vertragsliste',
        component: ContractListComponent,
      },
      {
        path: 'warenkorb',
        component: CartComponent,
      },
      {
        path: 'signature',
        component: CheckoutComponent,
      },
      {
        path: 'unauthorized',
        component: UnauthorizedComponent
      }
    ]
  }
];
